import React, { useState, useEffect } from "react";
import { setTitle } from "../../helpers/MetaTag";
import Select from "../../components/form/Select";
import Button from "../../components/form/Button";
import Table from "../../components/elements/table/Table";
import Search from "../../components/form/Search";
import { postData } from "../../services/api";
import moment from "moment";
import toastr from "toastr";

import { useTranslation } from "react-i18next";
import Pagination from "../../components/Common/Pagination";

export default function Banner() {
  setTitle("Succession Planning Software for your Business with Succession Now | Banners");
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [keyword, setKeyword] = useState("");
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [noOfPage, setNoOfPage] = useState(0);
  const [banner, setBanner] = useState("");
  const [totalDataCount, setTotalDataCount] = useState(0);
  const [startDataCount,setStartDataCount] = useState(0);
  const [endDataCount,setEndDataCount] = useState(0);
  const [actionValue, setActionValue] = useState({});
  const [isUpdate, setIsUpdate] = useState(true);

  const tableHeadData = [
    { _id: 1, width: 15, name: t("image"), value: "image", align: "left", isSort: true, isFilter: false },
    { _id: 2, width: 40, name: t("title"), value: "title", align: "left", isSort: false, isFilter: false },
    { _id: 3, width: 15, name: t("sub_title"), value: "Short Description", align: "left", isSort: true, isFilter: false },
    { _id: 4, width: 20, name: t("created_date"), value: "created_at", align: "left", isSort: false, isFilter: false },
    { _id: 5, width: 20, name: t("status"), value: "status", align: "left", isShort: false, isFilter: false },
    { _id: 6, width: 20, name: t("action"), value: "action", align: "left", isShort: false, isFilter: false },
  ];
  
  useEffect(() => {
    const loadList = async () => {
      setLoading(true);
      const result = await postData("banner/list", {
        keyword: keyword,
        offset: offset,
        sortQuery: {"created_at":-1},
      });
      if (result.data) {
        setBanner(
          result.data.map((value, key) => {
            return {
              _id: value?._id,
              rowData: [
                { _id: 1, width: 40, type: "image", data: "", image: value?.image },
                { _id: 2, width: 15, type: "text", data: value?.name },
                { _id: 3, width: 15, type: "text", data: value?.sub_title },
                { _id: 4, width: 20, type: "text", data: value && value?.created_at ? moment(new Date(value?.created_at)).format("Do MMM YYYY") : "N/A" },
                { _id: 5, width: 15, type: "status", statusLabel: value?.status && value?.status === 1 ? t("active") : t("deactivated"), statusType: value?.status && value?.status === 1 ? "success" : "warning" },
                { _id: 6, width: 10, type: "action", statusLabel: value?.status && value?.status === 1 ? t("active") : t("deactivated"), statusType: value?.status && value?.status === 1 ? "success" : "warning" },
              ],
            };
          })
        );
        setTotalDataCount(result.count);
        setLoading(false);
      }
    };
    loadList();
  }, [keyword, limit,offset, isUpdate,t]);

  useEffect(() => {
    setNoOfPage(Math.ceil(totalDataCount / limit));
    const startItem = Number((totalDataCount>0)?1:0);
    const endItem = Math.min(startItem + limit - 1, totalDataCount);
    setStartDataCount(startItem);
    setEndDataCount(endItem)
  }, [limit, totalDataCount]);

  const handlePageClick = (event) => {
    const newOffset = (event.selected * limit) % totalDataCount;
    console.log(`User requested page number ${event.selected}, which is offset ${newOffset}`);
    setOffset(newOffset);
    const startItem = Number(newOffset + 1);
    const endItem = Math.min(startItem + limit - 1, totalDataCount);
    setStartDataCount(startItem);
    setEndDataCount(endItem)
  };

  //   edit and status
  useEffect(() => {
    if (actionValue && actionValue.button_type === "status") {
      const loadStatusChange = async () => {
        setIsUpdate(false);
        try {
          const statusData = await postData("banner/status-change", {
            id: actionValue?.row_id,
            status: actionValue?.current_status,
          });
          if (statusData.data) {
            setBanner((banner) =>
              banner.map((it) => {
                if (it?._id === statusData.data?._id) {
                  return {
                    ...it,
                    status: statusData.data?.status,
                  };
                } else {
                  return it;
                }
              })
            );
            setIsUpdate(true);
            toastr.success(statusData.message);
          } else {
            toastr.error(statusData.message);
          }
        } catch (error) {
          toastr.error(error.message);
        }
      };
      loadStatusChange();
    } else if (actionValue?.row_id && actionValue?.button_type === "delete") {
      // delete
      const deleteBanner = async () => {
        const statusData = await postData("banner/delete", {
          id: actionValue?.row_id,
        });

        if (statusData.status === 200) {
          setBanner((bannerData) => bannerData.filter((item) => item._id !== actionValue.row_id));
          toastr.success(statusData.message);
        } else {
          toastr.error(statusData.message);
        }
      };
      deleteBanner();
    }
  }, [actionValue]);

  return (
    <div className="border bg-white border-gray-200 p-4 shadow-md rounded-xl">
      <div className="relative flex justify-between items-center mb-3">
        <div className="text-2xl font-bold">{t("banners")}</div>
        <div className="sm:ml-auto flex justify-end items-center">
          <Button buttonType={"button"} buttonIcon={"fa-light fa-plus"} buttonIconPosition={"left"} buttonLabel={t("add")} buttonHasLink={true} buttonLink={"/add-banner"} />
        </div>
      </div>
      <div className="relative flex gap-3 items-center mb-4 flex-wrap sm:flex-nowrap gap-y-2">
        <div className="relative">
          <Select
            xPlacement={"left"}
            dropdownButtonClass={"!bg-white"}
            selectedValue={limit}
            dropdownData={[
              { _id: 1000000, label: t("all_items"), value: 1000000 },
              ...[
                { _id: 10, label: "10 " + t("items"), value: 10 },
                { _id: 20, label: "20 " + t("items"), value: 20 },
                { _id: 30, label: "30 " + t("items"), value: 30 },
                { _id: 50, label: "50 " + t("items"), value: 50 },
                { _id: 100, label: "100 " + t("items"), value: 100 },
              ],
            ]}
            getSelectedValue={(e) => setLimit(e.value)}
          />
        </div>
        <div className="relative w-48">
            <Search placeholder={t("search")} setInput={setKeyword} />
          </div>
      </div>
      <div className="w-full bg-white rounded-md shadow overflow-hidden">
        <Table tableData={banner} tableHeadData={tableHeadData} loading={loading} totalRecord={totalDataCount} editUrl={"/edit-banner"} isDraggable={false} isDeleteEnabled isStatusUpdate={true} getActionValue={(obj) => setActionValue(obj)} />
      </div>
      {noOfPage > 1 ? (
        <Pagination handlePageClick={handlePageClick} noOfPage={noOfPage} startDataCount={startDataCount} endDataCount={endDataCount} count={totalDataCount}/>
      ):(
        <div className="flex justify-center sm:justify-between my-4 text-sm text-black text-center sm:text-left">
          {(totalDataCount > 0) ? <div><p>{t('showing')}: {startDataCount} to {endDataCount} of {totalDataCount}</p></div>:''}          
        </div>
      )}
    </div>
  );
}
